import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '24fr 14fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '5fr 1fr 1fr'
    }
  },
  code: {
    // [theme.breakpoints.down('sm')]: {
    //   textAlign: 'center'
    // }
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '24fr 15fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    // backgroundColor: theme.palette.background.paper,
    borderRadius: 20,
    // paddingLeft: 12,
    // transition: 'background-color 0.3s ease-in-out',
    width: '100%'
    // textAlign: 'unset'
    // '&:hover': {
    //   backgroundColor: '#f0f0f0'
    // }
  },
  skeleton: {
    width: '60%'
  }
}))
export default useStyles
